export default __webpack_public_path__ + "static/media/1.835ea61c.jpeg";